// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header---1JDZ6","Header__column_left":"Header__column_left---2Qb8E","Header__column_right":"Header__column_right---1coBl","Header__column_center":"Header__column_center---34YrN","Header__back_btn":"Header__back_btn---2uHc2","Header__close_btn":"Header__close_btn---3JXuX","Header__compose_btn":"Header__compose_btn---13lvL","Header__back_link":"Header__back_link---2IKiU"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/widget/Header/style.styl
// module id = plFh
// module chunks = 88